import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import './ProgressBar.scss';

export interface ProgressProps {
	selected: number;
	labels: string[];
	subLabel?: { index: number; label: string };
}

const progressBarClassNameHandler = (selected: number, index: number) => {
	const isEnabledClass = selected === index && 'enabled';
	const isDisabledClass = selected < index && 'disabled';
	return isEnabledClass || isDisabledClass || '';
};

export const ProgressBar: FunctionComponent<ProgressProps> = memo(({ labels, selected, subLabel }) => {
	const subLabelIndex = subLabel && subLabel.index;

	const elements = labels.map((item, index) => {
		const activeClass = progressBarClassNameHandler(selected, index);
		const secondaryLabel = subLabelIndex === index ? subLabel!.label : '';

		return (
			<li key={'Step' + index} className={`stepper__step ${activeClass}`}>
				<span className="stepper__step__label">{`${index + 1}. ${item}`}</span>
				<div className="stepper__step__point"></div>
				<span className="stepper__step__label-secondary">{secondaryLabel}</span>
			</li>
		);
	});
	return <ul className="stepper">{elements}</ul>;
});
